/*
  Hague House — shared game logic (window.HPHouse).
  Progress lives in this browser (localStorage). Emails go to Shopify
  customers through the standard customer (newsletter) form, tagged
  "hague-house" plus one tag per product found.
*/
(function () {
  if (window.HPHouse) return;

  var KEY = 'hp_house_v1';
  var ROOMS = ['closet', 'locker', 'wash', 'garage'];

  function blank() { return { email: '', puzzle: false, found: [], lives: {}, lockUntil: {} }; }
  function read() {
    try {
      var s = JSON.parse(localStorage.getItem(KEY) || '{}');
      var b = blank();
      for (var k in b) if (s[k] == null) s[k] = b[k];
      return s;
    } catch (e) { return blank(); }
  }
  function write(s) { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }

  function normalize(str) {
    var s = String(str || '');
    if (s.normalize) s = s.normalize('NFKD').replace(/[̀-ͯ]/g, '');
    return s.toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function distance(a, b) {
    if (a === b) return 0;
    var m = a.length, n = b.length;
    if (!m) return n; if (!n) return m;
    var prev = [], cur = [], i, j;
    for (j = 0; j <= n; j++) prev[j] = j;
    for (i = 1; i <= m; i++) {
      cur[0] = i;
      for (j = 1; j <= n; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      }
      var t = prev; prev = cur; cur = t;
    }
    return prev[n];
  }

  var api = {
    rooms: ROOMS,
    get: read,
    set: function (patch) { var s = read(); for (var k in patch) s[k] = patch[k]; write(s); return s; },
    reset: function () { write(blank()); },

    markFound: function (room) {
      var s = read();
      if (s.found.indexOf(room) === -1) s.found.push(room);
      delete s.lockUntil[room];
      write(s);
      return s;
    },
    livesLeft: function (room, max) {
      var s = read();
      return s.lives[room] == null ? max : s.lives[room];
    },
    loseLife: function (room, max, lockHours) {
      var s = read();
      var left = (s.lives[room] == null ? max : s.lives[room]) - 1;
      s.lives[room] = Math.max(0, left);
      if (left <= 0) s.lockUntil[room] = Date.now() + Math.max(0.05, lockHours) * 3600000;
      write(s);
      return s.lives[room];
    },
    // ms until the room can be played again (0 = playable). Resets lives when the wait is over.
    lockedFor: function (room, max) {
      var s = read();
      var until = s.lockUntil[room] || 0;
      if (!until) return 0;
      if (until <= Date.now()) { delete s.lockUntil[room]; s.lives[room] = max; write(s); return 0; }
      return until - Date.now();
    },

    isEmail: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || '').trim()); },

    // Case/space/punctuation-insensitive; a small typo is fine on longer answers.
    matches: function (guess, answers) {
      var g = normalize(guess);
      if (!g) return false;
      var gs = g.replace(/ /g, '');
      for (var i = 0; i < answers.length; i++) {
        var a = normalize(answers[i]);
        if (!a) continue;
        var as = a.replace(/ /g, '');
        if (g === a || gs === as) return true;
        var tol = as.length >= 9 ? 2 : as.length >= 5 ? 1 : 0;
        if (tol && distance(gs, as) <= tol) return true;
      }
      return false;
    },

    // Shopify customer form, posted into a hidden frame so the game never leaves the page.
    subscribe: function (email, tags) {
      if (!api.isEmail(email)) return;
      var name = 'hh-sub-frame';
      var frame = document.querySelector('iframe[name="' + name + '"]');
      if (!frame) {
        frame = document.createElement('iframe');
        frame.name = name;
        frame.title = 'Newsletter';
        frame.setAttribute('aria-hidden', 'true');
        frame.tabIndex = -1;
        frame.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden;';
        document.body.appendChild(frame);
      }
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var form = document.createElement('form');
      form.method = 'post';
      form.action = root + 'contact#hh-contact';
      form.target = name;
      form.style.display = 'none';
      var fields = {
        form_type: 'customer',
        utf8: '✓',
        'contact[email]': String(email).trim(),
        'contact[tags]': ['hague-house'].concat(tags || []).join(', ')
      };
      for (var k in fields) {
        var i = document.createElement('input');
        i.type = 'hidden'; i.name = k; i.value = fields[k];
        form.appendChild(i);
      }
      document.body.appendChild(form);
      form.submit();
      setTimeout(function () { form.remove(); }, 3000);
    },

    // Loading screen: the house drawing draws itself, rooms light up, messages
    // change, then the screen rolls up like a garage door.
    loader: function (el) {
      if (!el) return { set: function () {}, done: function () {} };
      var pctEl = el.querySelector('[data-pct]');
      var bar = el.querySelector('[data-bar]');
      var msgEl = el.querySelector('[data-loading-msg]');
      var sign = el.querySelector('.hh-lsign');
      var rooms = el.querySelectorAll('[data-room-fill]');
      var pins = el.querySelectorAll('[data-room-pin]');
      var paths = Array.prototype.slice.call(el.querySelectorAll('[data-draw]'));
      var lens = paths.map(function (p) {
        var L = 400;
        try { L = Math.ceil(p.getTotalLength()) + 2; } catch (e) {}
        p.style.strokeDasharray = L + ' ' + L;
        p.style.strokeDashoffset = L;
        return L;
      });
      var total = lens.reduce(function (a, b) { return a + b; }, 0) || 1;
      function drawTo(f) {
        var target = f * total, acc = 0;
        for (var i = 0; i < paths.length; i++) {
          var seg = Math.max(0, Math.min(lens[i], target - acc));
          paths[i].style.strokeDashoffset = lens[i] - seg;
          acc += lens[i];
        }
      }
      var MSGS = [
        [0, msgEl ? msgEl.textContent : 'Unlocking the front door…'],
        [18, 'Polishing the floors…'],
        [36, 'Lacing up the sneakers…'],
        [54, 'Stocking the lockers…'],
        [72, 'Hiding the products…'],
        [92, 'Almost spotless…'],
        [100, 'Come on in!']
      ];
      var ROOM_AT = [72, 80, 88, 95];
      var msgIdx = 0;
      function setMsg(v) {
        var idx = 0;
        for (var i = 0; i < MSGS.length; i++) if (v >= MSGS[i][0]) idx = i;
        if (idx === msgIdx || !msgEl) return;
        msgIdx = idx;
        msgEl.classList.add('is-swap');
        setTimeout(function () { msgEl.textContent = MSGS[idx][1]; msgEl.classList.remove('is-swap'); }, 220);
      }

      var shown = 0, target = 6, finished = false;
      var started = performance.now();
      function step(now) {
        // creep forward while waiting so it never looks stuck
        if (!finished && target < 88) target = Math.max(target, Math.min(88, 6 + (now - started) / 60));
        shown += Math.max(0.35, (target - shown) * 0.1);
        if (shown > target) shown = target;
        var v = Math.round(shown);
        if (pctEl) pctEl.textContent = v;
        if (bar) bar.style.width = v + '%';
        drawTo(Math.min(1, shown / 70));
        if (sign) sign.classList.toggle('is-on', v >= 58);
        for (var r = 0; r < rooms.length; r++) {
          rooms[r].classList.toggle('is-on', v >= ROOM_AT[r]);
          if (pins[r]) pins[r].classList.toggle('is-on', v >= ROOM_AT[r] + 3);
        }
        setMsg(v);
        if (shown >= 100) {
          setTimeout(function () { el.classList.add('is-done'); }, 450);
          setTimeout(function () { el.remove(); }, 1500);
          return;
        }
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      return {
        set: function (p) { target = Math.max(target, Math.min(99, Math.round(p * 100))); },
        done: function () { finished = true; target = 100; }
      };
    },

    confetti: function () {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var box = document.createElement('div');
      box.className = 'hh-confetti';
      var cols = ['#2563eb', '#111318', '#f5c84b', '#a9c1ff', '#ffffff'];
      for (var i = 0; i < 90; i++) {
        var p = document.createElement('i');
        p.style.left = Math.random() * 100 + '%';
        p.style.background = cols[i % cols.length];
        p.style.border = '1px solid rgba(17,19,24,.25)';
        p.style.setProperty('--dx', (Math.random() - 0.5) * 240 + 'px');
        p.style.setProperty('--rot', (Math.random() * 900 - 450) + 'deg');
        p.style.animationDuration = 1.6 + Math.random() * 1.6 + 's';
        p.style.animationDelay = Math.random() * 0.4 + 's';
        box.appendChild(p);
      }
      document.body.appendChild(box);
      setTimeout(function () { box.remove(); }, 4200);
    },

    countdown: function (ms) {
      var s = Math.max(0, Math.ceil(ms / 1000));
      var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      function p(n) { return (n < 10 ? '0' : '') + n; }
      return (h ? h + ':' : '') + p(m) + ':' + p(sec);
    },

    shoeIcon: '<svg width="28" height="18" viewBox="0 0 28 18" fill="currentColor" aria-hidden="true"><path d="M2 12.5c0-2.4 1.1-6.6 2.2-8.3.5-.8 1.6-1 2.3-.4 1.4 1.2 3.1 2 5 2 1 0 1.6-.6 2.3-1.3.4-.4 1-.5 1.5-.2l4.6 2.9c1.5.9 3.3 1.5 5.1 1.7 1.4.2 2.5 1.3 2.5 2.7v1.2c0 .7-.6 1.2-1.2 1.2H3.2c-.7 0-1.2-.6-1.2-1.5Z"/><rect x="1" y="14.6" width="26.5" height="2.4" rx="1.2" fill="currentColor" opacity=".55"/></svg>'
  };

  window.HPHouse = api;
})();
